export default "__VITE_ASSET__DnJiA5G8__"